module.exports = __webpack_public_path__ + "img/toyota-Used.30f5884a.png";